import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CalendarClock, ClipboardList, PhoneCall, UserCheck, UploadCloud } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const ICON = { bando: CalendarClock, task: ClipboardList, assegnato: UserCheck, richiesta_call: PhoneCall, upload_cliente: UploadCloud };

export function NotificheBell() {
  const [data, setData] = useState({ items: [], non_lette: 0, totale: 0 });
  const navigate = useNavigate();
  useEffect(() => {
    const load = () => api.get("/notifiche").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  const apri = async (n) => {
    if (n.evento) { setData((d) => ({ ...d, items: d.items.filter((x) => x.id !== n.id), totale: d.totale - 1, non_lette: d.non_lette - (n.urgente ? 1 : 0) })); api.post(`/notifiche/${n.id}/letta`).catch(() => {}); }
    navigate(n.link);
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="relative h-9 w-9 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-600 hover:text-[#003087] hover:border-[#003087]/40 transition-colors" data-testid="notifiche-bell" aria-label="Notifiche">
          <Bell size={17} strokeWidth={1.6} />
          {data.totale > 0 && <span className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-semibold text-white flex items-center justify-center ${data.non_lette ? "bg-red-500" : "bg-[#003087]"}`} data-testid="notifiche-badge">{data.totale}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="notifiche-panel">
        <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between"><div className="text-sm font-medium text-slate-900">Notifiche</div><div className="text-xs text-slate-500">{data.non_lette} urgenti · {data.totale} totali</div></div>
        <div className="max-h-96 overflow-y-auto divide-y divide-slate-100">
          {data.items.length === 0 && <div className="px-4 py-8 text-sm text-slate-500 text-center" data-testid="notifiche-vuoto">Nessuna scadenza imminente. Ottimo lavoro.</div>}
          {data.items.map((n) => { const Icon = ICON[n.tipo] || Bell; return (
            <button key={n.id} type="button" onClick={() => apri(n)} className={`w-full text-left px-4 py-3 flex gap-3 hover:bg-slate-50 transition-colors ${n.evento ? "bg-blue-50/40" : ""}`} data-testid={`notifica-${n.tipo}`}>
              <span className={`h-8 w-8 shrink-0 rounded-full flex items-center justify-center ${n.urgente ? "bg-red-50 text-red-600" : "bg-blue-50 text-[#003087]"}`}><Icon size={15} /></span>
              <span className="min-w-0"><span className="block text-sm font-medium text-slate-900 truncate">{n.titolo}</span><span className="block text-xs text-slate-500">{n.testo}</span></span>
            </button>); })}
        </div>
        <div className="px-4 py-2 border-t border-slate-100 text-[11px] text-slate-400">Le stesse scadenze arrivano anche via email ogni mattina alle 08:00.</div>
      </PopoverContent>
    </Popover>
  );
}
